import React from "react"
import { useEffect, useRef } from "react"
import Image from "aldoo-ra/Image"


const TTTopBg = () => {
  const ttPageTopBgRef = useRef(null)

  //get the parent container and set position to relative and z-index to 0
  //this will allow the bubbles to be behind the content
  useEffect(() => {
    const parent = ttPageTopBgRef.current.parentElement
    parent.style.position = "relative"
    parent.style.zIndex = 0
  }, [])

  {/* Top Gradient background + radial blurred image */}
  return (
    <div
      ref={ttPageTopBgRef}
      className="absolute top-0 left-0 w-full h-[1190px] bg-gradient_tt_top/50"
    >
      <Image
        id="T&TTopBackground"
        className="w-full h-auto object-cover"

      />
    </div>
  );
};

export default TTTopBg;